<template>
    <DialogSlot
        :title="isTitle"
        maxw="xl2"
        :open="isOpenModal"
        @close="() => isOpenModal = false"
    >
        <template #content>
            <div
                v-if="isUpload"
                class="absolute -top-4 left-0 w-full h-full flex items-center justify-center bg-neutral-700 bg-opacity-75 transition-opacity"
            >
                <div class="flex flex-col items-center  py-4 ">
                    <img
                        src="@/assets/images/others/spinner.svg"
                        alt=""
                        class="w-10 h-10 mr-2"
                    >
                    <span class="dark:text-gray-200"> Fazendo o upload, Aguarde ... </span>
                </div>
            </div>
            <ModalLibrary
                :type="type"
                :disable="isRecording"
                @selected="handleSelected"
                @request="value => isRequest = value"
            />
            <input
                ref="target"
                type="file"
                class="sr-only"
                :accept="dataPage[type].accept"
                @change="handleUpload"
            >
        </template>
        <template #footer>
            <div
                v-if="isRecording"
                class="w-full px-2"
            >
                <RecordAudio />
            </div>

            <div
                v-else
                class="flex justify-between w-full"
            >
                <div class="flex">
                    <ButtonForm
                        v-if="type === 'audioo'"
                        icon="microphone"
                        type="buttom"
                        color="gray"
                        content=""
                        @click="handleNewAudio"
                    />
                    <ButtonForm
                        icon="upload"
                        type="buttom"
                        color="gray"
                        content="Novo arquivo"
                        :disabled="isRequest"
                        @click="target.click()"
                    />
                </div>
                <div class="flex">
                    <ButtonForm
                        type="buttom"
                        color="gray"
                        content="Cancelar"
                        @click="handleCancel"
                    />
                    <ButtonForm
                        icon="check"
                        type="buttom"
                        color="primary"
                        content="Aplicar"
                        @click="handleApply"
                    />
                </div>
            </div>
        </template>
    </DialogSlot>
    <span
        class="flex justify-center cursor-pointer  w-full p-3 border-2 border-gray-300 border-dashed border-opacity-50 hover:border-opacity-100 dark:text-neutral-300 text-sm chat_transition rounded-md "
        @click="handleOpenModal"
    >
        {{ title }}
    </span>
    <div
        v-if="isSelected != '' && !isOpenModal"
        class="flex items-center space-x-4  dark:bg-neutral-600 p-4 rounded-lg animate_Animated animate_FadeIn "
    >
        <div class="flex-shrink-0">
            <img
                v-if="isSelected.type === 'image'"
                :src="isSelected.source"
                :alt="isSelected.title"
                class="object-cover object-center pointer-events-none group-hover:opacity-75 w-10 h-50 rounded-lg"
                @error="fixedNoPhoto"
            >
            <Unicon
                v-else
                :name="isSelectLibrary[isSelected.type].icon"
                class="mt-1 w-6 h-6 dark:text-neutral-300"
            />
        </div>
        <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-900 truncate dark:text-white">
                {{ isSelected.name }}
            </p>
            <p class="text-sm text-gray-500 truncate dark:text-gray-400">
                {{ isSelected.size }}
            </p>
        </div>
        <div class="inline-flex items-center text-base font-semibold dark:font-normal text-gray-900 dark:text-white">
            <ButtonForm
                icon="trash-alt"
                type="buttom"
                color="red"
                content=""
                :hiddenMdText="true"
                @click="isSelected = ''; emit('selected', '')"
            />
        </div>
    </div>
</template>
<script setup>
    import { defineProps, defineEmits, ref, computed, onBeforeMount, watch } from 'vue';
    import DialogSlot from '@/components/dialog/DialogSlot.vue'
    import ButtonForm from '@/components/utils/ButtonForm.vue'
    import ModalLibrary from './ModalLibrary.vue'
    import RecordAudio from './RecordAudio.vue'
    import { fixedNoPhoto } from '@/utils/image'
    import { dataPage, isSelectLibrary } from './utils'
    import { useLibraryStore } from '@/stores/library'
    import { notify } from '@kyvg/vue3-notification'

    const emit = defineEmits(['selected'])
    const props = defineProps({
        title: {
            type: String,
            default: 'Clique aqui para selecionar um  arquivo',
        },
        type: {
            type: String,
            default: 'image',
        },
        source: {
            type: String,
            default: '',
        },
    })

    const library = useLibraryStore()

    const target = ref(null)
    const isOpenModal = ref(false)
    const isSelected = ref('')
    const isRecording = ref(false)
    const isUpload = ref(false)
    const isRequest = ref(false)

    const isTitle = computed(() => dataPage[props.type].title)

    const handleSelected = (value) => {
        isSelected.value = value
    }

    const handleOpenModal = () => isOpenModal.value = true

    function handleApply() {
        if (isSelected.value?.source) {
            emit('selected', isSelected.value)
            isOpenModal.value = false
        } else {
            notify({ type: 'warning', title: 'Selecione um item para aplicar'})
        }
    }

    function handleCancel() {
        isOpenModal.value = false
        syncSelectedFromSource()
    }

    function syncSelectedFromSource() {
        if (!props.source) {
            isSelected.value = ''
            return
        }

        const fromLibrary = library.all.find(
            (item) => item.source === props.source && item.type === props.type,
        )

        isSelected.value = fromLibrary ?? {
            source: props.source,
            type: props.type,
            name: 'Imagem selecionada',
        }
    }

    async function handleUpload(e) {
        try{
            e.preventDefault()
            isUpload.value = true
            await library.uploadItem(e.target.files[0])
            isUpload.value = false
        }catch(e){
            notify({ type: 'error', title: e.message})
        }
    }

    function handleNewAudio() {
        isRecording.value = !isRecording.value

    }

    onBeforeMount(async () => {
        if (library.all.length === 0) {
            await library.fetchItems(props.type)
        }

        syncSelectedFromSource()
    })

    watch(() => props.source, syncSelectedFromSource)

    watch(() => library.all, () => {
        if (!props.source || isOpenModal.value) {
            return
        }

        syncSelectedFromSource()
    }, { deep: true })

</script>
